import { render } from "./FreeCommission.vue?vue&type=template&id=a318a5d2&scoped=true"
import script from "./FreeCommission.vue?vue&type=script&lang=js"
export * from "./FreeCommission.vue?vue&type=script&lang=js"

import "./FreeCommission.vue?vue&type=style&index=0&id=a318a5d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a318a5d2"]])

export default __exports__